import api from 'api/client';
import { queryResponseValidator } from 'helpers/queryUtils';
import z from 'zod';
import { STATUS } from './types';

const companyCodeSchema = z.object({
  code: z.string(),
  isEligibilityCheckRequired: z.boolean(),
  accessType: z.enum(['GRANTS_PREMIUM', 'SELF_PAY']).optional(),
});

const companyCodesResponseSchema = z.object({
  status: z.enum([STATUS.OK, STATUS.ERROR]),
  total: z.number(),
  items: z.array(companyCodeSchema),
});

export type CompanyCode = z.infer<typeof companyCodeSchema>;
type CompanyCodesResponse = z.infer<typeof companyCodesResponseSchema>;

export type ApplyCompanyCodeParams = {
  userId: string;
  companyCode: string;
};

export const getCompanyCodes = async (): Promise<CompanyCodesResponse> => {
  return api
    .get('checkout/company-codes')
    .json()
    .then(
      queryResponseValidator<CompanyCodesResponse>(companyCodesResponseSchema)
    );
};

export const applyCompanyCode = async ({
  userId,
  companyCode,
}: ApplyCompanyCodeParams) => {
  return api
    .put(`checkout/apply-company-code/${userId}`, { json: { companyCode } })
    .json();
};
